import React from 'react';
import { Link } from 'react-router-dom';

function ProductCard({ product, backgroundGradient }) {
  return (
    <div className="col-12 col-lg-3 col-md-6 mb-2">
      <div
        className="h_250x d-flex flex-column justify-content-center px-4 rounded-4"
        style={{ background: backgroundGradient }}
      >
        <h3 className="text-white mb-2 font_19">{product.productTitle}</h3>
        <p className="text-white font_14 font_400">{product.productSubTitle}</p>
        <div>
          <div className=" mb-3 font_600 rounded-pill text-white w_fit_content">
            {`${product.productWeightage} credit/ Hit`}
          </div>
          {product.isActive ? (
            <Link
              className="text-white text-decoration-none cardIconMain font_13 w_fit_content px-3 py-2 rounded-pill"
              to={`/login?redirectProduct=${
                product.productId
              }&category=${encodeURIComponent(product.productCategory || '')}`}
            >
              Try Now <i className="fas fa-arrow-right text-white ms-1"></i>
            </Link>
          ) : (
            <span className="coming-soon-badge text-white font_13 font_400">
              🚀 Coming Soon
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
